import { FC, Fragment } from "react";
import { FormControl, RadioGroup, makeStyles, createStyles } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

const useFormControlStyles = makeStyles(() =>
    createStyles({
        container: {
            display: "flex",
            flexDirection: "row",
        },
        firstFormControlLabelStyle: {
            marginRight: 64,
        },
    }),
);

export const ChargerConnectionPillarDeliveredBySystemOperatorForm: FC = () => {
    const { values, setValues } =
        useFormModel<ChangeNames.CHARGER_CONNECTION_PILLAR_DELIVERED_BY_SYSTEM_OPERATOR>();

    const convertValue = (): string => {
        if (values.chargerConnectionPillarDeliveredBySystemOperator.value.yes) return "yes";
        if (values.chargerConnectionPillarDeliveredBySystemOperator.value.no) return "no";
        return "";
    };

    const classes = useStyles();
    const formControlStyles = useFormControlStyles();
    const selection = convertValue();

    return (
        <Fragment>
            <div className={classes.container} style={{ marginBottom: 16 }}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Hausanschlusssäule
                </h4>
                <p className={classes.p} style={{ marginBottom: 0, marginTop: 16 }}>
                    Bitte geben Sie an, von wem die Hausanschlusssäule bezogen werden soll.
                    <br />
                    Gerne erstellen wir Ihnen hierzu ein Angebot.
                </p>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues((values) => {
                                values.chargerConnectionPillarDeliveredBySystemOperator.value = {
                                    yes: v.includes("yes"),
                                    no: v.includes("no"),
                                };
                            });
                        }}
                    >
                        <FormControlLabel
                            className={formControlStyles.firstFormControlLabelStyle}
                            value="yes"
                            control={<Radio />}
                            label="Von Syna"
                            error={
                                values.chargerConnectionPillarDeliveredBySystemOperator.error !==
                                null
                            }
                        />
                        <FormControlLabel
                            value="no"
                            control={<Radio />}
                            label="Eigene Hausanschlusssäule"
                            error={
                                values.chargerConnectionPillarDeliveredBySystemOperator.error !==
                                null
                            }
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
